// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Photo from "./photo.js"
import PhotoSheetProductOrderLine from "./photo-sheet-product-order-line.js"
import SheetLayoutBox from "./sheet-layout-box.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "photo_id": {
      "column": {
        "default": null,
        "name": "photo_id",
        "null": false,
        "type": "uuid"
      },
      "name": "photo_id",
      "selected_by_default": null,
      "translated": null
    },
    "photo_left_percent": {
      "column": {
        "default": null,
        "name": "photo_left_percent",
        "null": false,
        "type": "decimal"
      },
      "name": "photo_left_percent",
      "selected_by_default": null,
      "translated": null
    },
    "photo_top_percent": {
      "column": {
        "default": null,
        "name": "photo_top_percent",
        "null": false,
        "type": "decimal"
      },
      "name": "photo_top_percent",
      "selected_by_default": null,
      "translated": null
    },
    "photo_width_percent": {
      "column": {
        "default": null,
        "name": "photo_width_percent",
        "null": false,
        "type": "decimal"
      },
      "name": "photo_width_percent",
      "selected_by_default": null,
      "translated": null
    },
    "photo_height_percent": {
      "column": {
        "default": null,
        "name": "photo_height_percent",
        "null": false,
        "type": "decimal"
      },
      "name": "photo_height_percent",
      "selected_by_default": null,
      "translated": null
    },
    "photo_sheet_product_order_line_id": {
      "column": {
        "default": null,
        "name": "photo_sheet_product_order_line_id",
        "null": false,
        "type": "uuid"
      },
      "name": "photo_sheet_product_order_line_id",
      "selected_by_default": null,
      "translated": null
    },
    "rotation": {
      "column": {
        "default": 0,
        "name": "rotation",
        "null": false,
        "type": "integer"
      },
      "name": "rotation",
      "selected_by_default": null,
      "translated": null
    },
    "sheet_layout_box_id": {
      "column": {
        "default": null,
        "name": "sheet_layout_box_id",
        "null": false,
        "type": "uuid"
      },
      "name": "sheet_layout_box_id",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "PhotoSheetProductOrderLineBox",
  "collectionKey": "photo_sheet_product_order_line_boxes",
  "collectionName": "photo_sheet_product_order_line_boxes",
  "i18nKey": "photo_sheet_product_order_line_box",
  "camelizedLower": "photoSheetProductOrderLineBox",
  "name": "PhotoSheetProductOrderLineBox",
  "nameDasherized": "photo-sheet-product-order-line-box",
  "pluralName": "photo_sheet_product_order_line_boxes",
  "ransackable_associations": [
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Photo",
      "collectionName": "photos",
      "foreignKey": "photo_id",
      "name": "photo",
      "macro": "belongs_to",
      "resource_name": "Photo",
      "through": null
    },
    {
      "className": "PhotoSheetProductOrderLine",
      "collectionName": "photo_sheet_product_order_lines",
      "foreignKey": "photo_sheet_product_order_line_id",
      "name": "photo_sheet_product_order_line",
      "macro": "belongs_to",
      "resource_name": "PhotoSheetProductOrderLine",
      "through": null
    },
    {
      "className": "SheetLayout",
      "collectionName": "sheet_layouts",
      "foreignKey": "sheet_layout_id",
      "name": "sheet_layout",
      "macro": "has_one",
      "resource_name": "SheetLayout",
      "through": "photo_sheet_product_order_line"
    },
    {
      "className": "SheetLayoutBox",
      "collectionName": "sheet_layout_boxes",
      "foreignKey": "sheet_layout_box_id",
      "name": "sheet_layout_box",
      "macro": "belongs_to",
      "resource_name": "SheetLayoutBox",
      "through": null
    },
    {
      "className": "SheetSize",
      "collectionName": "sheet_sizes",
      "foreignKey": "sheet_size_id",
      "name": "sheet_size",
      "macro": "has_one",
      "resource_name": "SheetSize",
      "through": "photo_sheet_product_order_line"
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "photo_height_percent",
      "column": {
        "default": null,
        "name": "photo_height_percent",
        "null": false,
        "type": "decimal"
      }
    },
    {
      "name": "photo_id",
      "column": {
        "default": null,
        "name": "photo_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "photo_left_percent",
      "column": {
        "default": null,
        "name": "photo_left_percent",
        "null": false,
        "type": "decimal"
      }
    },
    {
      "name": "photo_sheet_product_order_line_id",
      "column": {
        "default": null,
        "name": "photo_sheet_product_order_line_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "photo_top_percent",
      "column": {
        "default": null,
        "name": "photo_top_percent",
        "null": false,
        "type": "decimal"
      }
    },
    {
      "name": "photo_width_percent",
      "column": {
        "default": null,
        "name": "photo_width_percent",
        "null": false,
        "type": "decimal"
      }
    },
    {
      "name": "rotation",
      "column": {
        "default": 0,
        "name": "rotation",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "sheet_layout_box_id",
      "column": {
        "default": null,
        "name": "sheet_layout_box_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Photo",
      "collectionName": "photos",
      "foreignKey": "photo_id",
      "name": "photo",
      "macro": "belongs_to",
      "resource_name": "Photo",
      "through": null
    },
    {
      "className": "PhotoSheetProductOrderLine",
      "collectionName": "photo_sheet_product_order_lines",
      "foreignKey": "photo_sheet_product_order_line_id",
      "name": "photo_sheet_product_order_line",
      "macro": "belongs_to",
      "resource_name": "PhotoSheetProductOrderLine",
      "through": null
    },
    {
      "className": "SheetLayoutBox",
      "collectionName": "sheet_layout_boxes",
      "foreignKey": "sheet_layout_box_id",
      "name": "sheet_layout_box",
      "macro": "belongs_to",
      "resource_name": "SheetLayoutBox",
      "through": null
    }
  ],
  "paramKey": "photo_sheet_product_order_line_box",
  "primaryKey": "id"
}

/** Frontend model for PhotoSheetProductOrderLineBox. */
export default class PhotoSheetProductOrderLineBox extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  photoId() {
    return this.readAttributeUnderscore("photo_id")
  }

  /** @returns {boolean} */
  hasPhotoId() {
    const value = this.photoId()

    return this._isPresent(value)
  }

  /** @returns {number} */
  photoLeftPercent() {
    return this.readAttributeUnderscore("photo_left_percent")
  }

  /** @returns {boolean} */
  hasPhotoLeftPercent() {
    const value = this.photoLeftPercent()

    return this._isPresent(value)
  }

  /** @returns {number} */
  photoTopPercent() {
    return this.readAttributeUnderscore("photo_top_percent")
  }

  /** @returns {boolean} */
  hasPhotoTopPercent() {
    const value = this.photoTopPercent()

    return this._isPresent(value)
  }

  /** @returns {number} */
  photoWidthPercent() {
    return this.readAttributeUnderscore("photo_width_percent")
  }

  /** @returns {boolean} */
  hasPhotoWidthPercent() {
    const value = this.photoWidthPercent()

    return this._isPresent(value)
  }

  /** @returns {number} */
  photoHeightPercent() {
    return this.readAttributeUnderscore("photo_height_percent")
  }

  /** @returns {boolean} */
  hasPhotoHeightPercent() {
    const value = this.photoHeightPercent()

    return this._isPresent(value)
  }

  /** @returns {string} */
  photoSheetProductOrderLineId() {
    return this.readAttributeUnderscore("photo_sheet_product_order_line_id")
  }

  /** @returns {boolean} */
  hasPhotoSheetProductOrderLineId() {
    const value = this.photoSheetProductOrderLineId()

    return this._isPresent(value)
  }

  /** @returns {number} */
  rotation() {
    return this.readAttributeUnderscore("rotation")
  }

  /** @returns {boolean} */
  hasRotation() {
    const value = this.rotation()

    return this._isPresent(value)
  }

  /** @returns {string} */
  sheetLayoutBoxId() {
    return this.readAttributeUnderscore("sheet_layout_box_id")
  }

  /** @returns {boolean} */
  hasSheetLayoutBoxId() {
    const value = this.sheetLayoutBoxId()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {import("./photo.js").default | null} */
  photo() {
    return this._readBelongsToReflection({modelClass: Photo, reflectionName: "photo"})
  }

  /** @returns {Promise<import("./photo.js").default | null>} */
  loadPhoto() {
    if (!("photoId" in this)) throw new Error("Foreign key method wasn't defined: photoId")

    const id = this.photoId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "photo",
        model: this,
        modelClass: Photo
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./photo.js").default | null>} */
  ensurePhotoLoaded() {
    return this.ensureAssociationLoaded("photo")
  }

  /** @returns {import("./photo-sheet-product-order-line.js").default | null} */
  photoSheetProductOrderLine() {
    return this._readBelongsToReflection({modelClass: PhotoSheetProductOrderLine, reflectionName: "photo_sheet_product_order_line"})
  }

  /** @returns {Promise<import("./photo-sheet-product-order-line.js").default | null>} */
  loadPhotoSheetProductOrderLine() {
    if (!("photoSheetProductOrderLineId" in this)) throw new Error("Foreign key method wasn't defined: photoSheetProductOrderLineId")

    const id = this.photoSheetProductOrderLineId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "photo_sheet_product_order_line",
        model: this,
        modelClass: PhotoSheetProductOrderLine
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./photo-sheet-product-order-line.js").default | null>} */
  ensurePhotoSheetProductOrderLineLoaded() {
    return this.ensureAssociationLoaded("photo_sheet_product_order_line")
  }

  /** @returns {import("./sheet-layout-box.js").default | null} */
  sheetLayoutBox() {
    return this._readBelongsToReflection({modelClass: SheetLayoutBox, reflectionName: "sheet_layout_box"})
  }

  /** @returns {Promise<import("./sheet-layout-box.js").default | null>} */
  loadSheetLayoutBox() {
    if (!("sheetLayoutBoxId" in this)) throw new Error("Foreign key method wasn't defined: sheetLayoutBoxId")

    const id = this.sheetLayoutBoxId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "sheet_layout_box",
        model: this,
        modelClass: SheetLayoutBox
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./sheet-layout-box.js").default | null>} */
  ensureSheetLayoutBoxLoaded() {
    return this.ensureAssociationLoaded("sheet_layout_box")
  }
}
